<template>
  <div class="collapse" :style="{width: width, height: height}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Collapse',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
  },
  data() {
    return {

    }
  },
  methods: {
    cut(childId) {
      this.$children.forEach(child => {
        if(child._uid !== childId) {
          child.show = false;
        }
      })
    }
  },
  mounted() {
    this.$children[2].show = true
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.collapse {
  display: flex;
}
</style>
